import React from 'react'

const Manual_cliente_extranjero_sv = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Creación de un Cliente Extranjero | El Salvador
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Si el cliente no reside en El Salvador y no posee NIT o NRC, se debe registrar como Cliente Extranjero. Sigue estos pasos:
        </p>
        <iframe
          src="https://scribehow.com/embed/Creacion_de_un_Cliente_Extranjeroor_El_Salvador___Syj_Q0HuSQKjDJL8JqNs7Q?as=scrollable"
          className="scribe-iframe-general-58"
          width="100%"
          height="7000"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cliente_extranjero_sv
